module.exports = __webpack_public_path__ + "static/media/je.2496385f.svg";